module.exports = __webpack_public_path__ + "img/content_three.45cf03dd.png";